import React from 'react';

const isNotEmpty = (string) => {
  return (string !== "" && string !== undefined && string !== null)
}

export default class SignUp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      userSignedUp: false
    }

    this.signUpForBasicEmail = this.signUpForBasicEmail.bind(this);
  }

  signUpForBasicEmail() {
    const form = {email: this.state.email};
    const searchParams = Object.keys(form).map((key) => {
      return encodeURIComponent(key) + '=' + encodeURIComponent(form[key]);
    }).join('&');

    (async () => {
      const rawResponse = await fetch(`${process.env.REACT_APP_API_HOST}/api/users/signup-basic`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        },
        body: searchParams
      })
      const content = await rawResponse.json();
      localStorage.setItem('userSignedUp', this.state.email);
      this.checkIfSignedUpBefore();

      return content;
    })();
  }

  checkIfSignedUpBefore() {
    const email = localStorage.getItem('userSignedUp');

    if (isNotEmpty(email)) {
      // user logged in
      this.setState({
        userSignedUp: true
      });
    }
  }

  componentDidMount() {
    this.checkIfSignedUpBefore();
  }

  handleChange(e) {
    this.setState({ email: e.target.value });
  }

  render() {
    const userSignedUp = this.state.userSignedUp;
    let show;

    if (userSignedUp) {
      // show = null;
      show = (
      <div className="footer-hide">
      </div>)
    } else {
      show = (
      <div className="footer-show">
        <div className="inputs">
          <input
            value={this.state.email}
            onChange={ this.handleChange.bind(this) }
            placeholder="First Name" />
          <input
            value={this.state.email}
            onChange={ this.handleChange.bind(this) }
            placeholder="Email" />
        </div>
        <button onClick={this.signUpForBasicEmail}>New Jobs Weekly</button>
      </div>)
    }

    return (
      <div className="footer">
        {show}
      </div>
    )
  }

  // methods
}
